import './news-blogs-listing-filters.html.twig';
import './news-blogs-listing-filters.scss'

const filters = {
  topics: [], // string[]
  type: null, // string
  tag: null, //string
};

function initializeFilters() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const entries = urlSearchParams.entries();

  Array.from(entries).forEach(([key, value]) => {
    if (key == 'topics') {
      filters[key] = value.split('_');
    } else {
      filters[key] = value;
    }
  });
}

function clearTopicFilter(value) {
  filters.topics = filters.topics.filter((topic) => {
    if (topic != value) return topic;
  });
}
  
function clearAllFilters() {
  filters.topics = [];
  filters.type = null;
  filters.tag = null;
}

function clearFilter(type, value) {
  switch (type) {
    case 'topics':
      clearTopicFilter(value);
      return;
    case 'type':
      filters.type = null;
      return;
    case 'tag': 
      filters.tag = null;
      return;
  }
}
  
function updatePageFilters() {
  const filterParams = `${filters.topics.length > 0 ? `&topics=${filters.topics.join('_')}` : ''}${
    filters.type != null ? `&type=${filters.type}` : ''}${
    filters.tag != null ? `&tag=${filters.tag}` : ''}`;

  if (filterParams.length > 0) {
    window.location.href = window.location.origin + window.location.pathname + filterParams.replace('&', '?');
    return;
  }

  window.location.href = window.location.origin + window.location.pathname;
}

export default function () {
  const el = document.querySelector('.news-blogs-listing-filters');
  if (el) {
    initializeFilters();
    console.log(filters);

    const activeFilters = el.querySelectorAll('.news-blogs-listing-filters__filter');
    activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener('click', () => {
        const type = activeFilter.getAttribute('data-filter-type');
        const value = activeFilter.getAttribute('data-filter-id');
        if (type) {
          clearFilter(type, value);
          updatePageFilters();
        }
      });
    });

    const removeAllLink = el.querySelector('.news-blogs-listing-filters__remove-all-link');
    if (removeAllLink) {
      removeAllLink.addEventListener('click', () => {
        clearAllFilters();
        updatePageFilters();
      });
    }
  }
}
